// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/chatRoute.test.tsx
// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { askV2AuthLayoutRoute } from "./authLayout";

import { AskV2ChatPage } from "../pages/AskV2ChatPage";

export const askV2ChatRoute = createRoute({
  getParentRoute: () => askV2AuthLayoutRoute,
  path: "ask-puntt/$chatId",
  component: AskV2ChatRoutePage,
});

function AskV2ChatRoutePage() {
  const { chatId } = askV2ChatRoute.useParams();
  // Key on chatId so navigating between two chats remounts the page and
  // re-seeds the ref-guarded transport in useAskV2Transport. Without it the
  // same instance persists across the param change, keeping the previous
  // chat's transport snapshot — a send would target the old chatId.
  return <AskV2ChatPage key={chatId} chatId={chatId} />;
}
